import React from 'react'
import { storage } from '../../../../../firebase'

export const useProductModelLoader = () => {

}

export type ProductModel = { model?: any, json?: string, flatModel?: any }

export const loadProductModel = async (tempSize: ProductModel): Promise<ProductModel> => {
    const productModel = { ...tempSize }
    if (tempSize.model) {
        productModel.model =
            tempSize.model.split("/")[0] !== "https"
                ? await storage.refFromURL(tempSize.model).getDownloadURL()
                : tempSize.model
    }
    if (tempSize.json) {
        productModel.json =
            tempSize.json.split("/")[0] !== "https"
                ? await storage.refFromURL(tempSize.json).getDownloadURL()
                : tempSize.json
    }
    return productModel
}